const Formats = function() {
  function amountWithCurrency(rawAmount) {
    return amountWithoutCurrency(rawAmount) + '\u00A0' + Currency
  }

  function amountWithoutCurrency(rawAmount, decimalPlaces) {
    const sign = rawAmount >= 0 ? '' : '-'
    const amount = Math.abs(rawAmount)
    const whole = splitThousandsWithSpaces(amount)
    const fixed = amount.toFixed(decimalPlaces || 2)
    const decimal = fixed.substring(fixed.indexOf('.') + 1)
    return sign + whole + '.' + decimal
  }

  function splitThousandsWithSpaces(amount) {
    return Math.floor(amount).toString().replace(/(\d)(?=(\d{3})+$)/g, '$1\u00A0')
  }

  function percentage(total, fraction) {
    return Math.round((fraction * 100) / total);
  }

  return {
    amountWithCurrency: amountWithCurrency,
    amountWithoutCurrency: amountWithoutCurrency,
    splitThousandsWithSpaces: splitThousandsWithSpaces,
    percentage: percentage
  }
}();